import { FC, HTMLAttributes } from 'react';
import classNames from 'classnames';

export interface PaymentMethodLabelProps extends HTMLAttributes<HTMLSpanElement> {}

// TODO: Consider abstracting this out to a more generic `Label` component.
export const PaymentMethodLabel: FC<PaymentMethodLabelProps> = ({ className, ...props }) => (
  <span
    className={classNames(
      'label inline-block text-xs md:text-sm font-medium pt-[0.25rem] md:pt-[0.375rem] pb-1 md:pb-2 px-3 md:px-5 bg-secondary rounded-full',
      className
    )}
    {...props}
  />
);
